<template>
  <div class="TranProgramModule-view-page w-100">
    <basic-subheader>
      <template v-slot:actions>
        <div class="header-buttons-container">
          <b-button
            v-if="viewMode === 'week'"
            class="btn btn-success"
            type="button"
            @click="showAddModuleModal"
          >
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
            </span>
            Thêm hoạt động
          </b-button>

          <div class="navigation-buttons">
            <b-button class="btn ml-3" type="button" @click="returnPage">
              <span class="svg-icon">
                <inline-svg
                  src="/media/svg/icons/Neolex/Arrows/arrow-left.svg"
                />
              </span>
              Trở về trước
            </b-button>
          </div>
        </div>
      </template>
    </basic-subheader>

    <ScheduleProgramModuleDay
      ref="ScheduleProgramModuleDay"
      @edit-activity="editActivity"
      @delete-activity="deleteActivity"
      :moduleData="moduleData"
      :moduleId="$route.params.id"
      :numberOfWeeks="numberOfWeeks"
    />

    <!-- Modal Thêm/Sửa Module -->
    <b-modal
      id="module-modal"
      ref="moduleModal"
      :title="isEditing ? 'Chỉnh sửa hoạt động' : 'Thêm hoạt động mới'"
      size="lg"
      hide-footer
      @hidden="resetModuleForm"
    >
      <div class="form-container">
        <div class="form-row d-flex">
          <basic-select
            label="Loại hoạt động"
            placeholder="Chọn loại hoạt động"
            :options="activityTypes"
            track-by="value"
            value-label="name"
            v-model="activityTypeForm.activityTypeId"
            @input="onActivityTypeChange"
          >
          </basic-select>
          <basic-select
            label="Hoạt động"
            placeholder="Chọn hoạt động"
            :options="filteredActivities"
            track-by="value"
            value-label="displayName"
            v-model="activityForm.activityId"
          ></basic-select>
          <div class="form-group" style="flex: 6">
            <label>Tuần bắt đầu</label>
            <select v-model="activityForm.startWeek" class="form-input">
              <option v-for="week in numberOfWeeks" :key="week" :value="week">
                Tuần {{ week }}
              </option>
            </select>
          </div>
          <div class="form-group" style="flex: 6">
            <label>Ngày bắt đầu</label>
            <select
              v-model="selectedDay"
              class="form-input"
              @change="updateStartAtDay"
            >
              <option v-for="(day, index) in days" :key="index" :value="index">
                {{ day }}
              </option>
            </select>
          </div>
        </div>
        <div class="modal-actions mt-4">
          <b-button
            variant="success"
            @click="handleSubmitActivity"
            class="mr-2"
          >
            {{ isEditing ? 'Cập nhật' : 'Thêm hoạt động' }}
          </b-button>
          <b-button variant="secondary" @click="hideModal"> Hủy </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ScheduleProgramModuleDay from './components/ScheduleProgramModuleDay.vue';

export default {
  components: {
    ScheduleProgramModuleDay,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      days: [
        'Ngày 1',
        'Ngày 2',
        'Ngày 3',
        'Ngày 4',
        'Ngày 5',
        'Ngày 6',
        'Ngày 7',
      ],
      loading: false,
      isFirstLoad: false,
      moduleData: {},
      viewMode: 'week',
      activityForm: {
        activityId: '',
        startWeek: 1,
        color: '#16A45A',
      },
      activityTypeForm: {
        activityTypeId: '',
      },
      activityType: null,
      activityTypes: [],
      activities: [],
      isEditing: false,
      editingId: null,
      numberOfWeeks: 0,
      selectedDay: 0,
      defaultColor: '16A45A',
    };
  },
  computed: {

    filteredActivities() {
      if (!this.activityTypeForm.activityTypeId) {
        return this.activities.map((activity) => ({
          ...activity,
          displayName: activity.code
            ? `(${activity.code}) ${activity.name}`
            : activity.name,
        }));
      }
      const selectedActivityTypeId =
        typeof this.activityTypeForm.activityTypeId === 'object'
          ? this.activityTypeForm.activityTypeId.value
          : this.activityTypeForm.activityTypeId;

      return this.activities
        .filter((activity) => activity.activityType === selectedActivityTypeId)
        .map((activity) => ({
          ...activity,
          displayName: activity.code
            ? `(${activity.code}) ${activity.name}`
            : activity.name,
        }));
    },

    activeScheduleComponent() {
      return this.$refs.ScheduleProgramModuleDay;
    },
    startAtDay() {
      return (this.activityForm.startWeek - 1) * 7 + this.selectedDay + 1;
    },
  },
  methods: {
    onActivityTypeChange() {
      this.activityForm.activityId = '';
    },
    returnPage() {
      this.$router.push({
        name: 'tran_program_module_list',
      });
    },
    showAddModuleModal() {
      this.resetModuleForm();
      this.$refs.moduleModal.show();
    },
    hideModal() {
      this.$refs.moduleModal.hide();
    },
    resetModuleForm() {
      this.activityForm = {
        activityId: '',
        activityTypeId: '',
        startWeek: 1,
        color: this.defaultColor,
      };
      this.activityTypeForm = {
        activityTypeId: '',
      };
      this.selectedDay = 0;
      this.isEditing = false;
      this.editingId = null;
    },
    updateStartAtDay() {
      this.activityForm.startAtDay = this.startAtDay;
    },
    async handleSubmitActivity() {
      if (!this.activityForm.activityId) {
        this.$swal('Lỗi!', 'Vui lòng chọn hoạt động', 'error');
        return;
      }
      try {
        this.loading = true;
        const tranprogramActivityId =
          typeof this.activityForm.activityId === 'object'
            ? this.activityForm.activityId.value
            : this.activityForm.activityId;

        const payload = {
          programActivityId: tranprogramActivityId,
          tranProgramModuleId: this.$route.params.id,
          startranAtranDay: this.startAtDay,
        };
        const target = this.activities.find(
          (a) =>
            a.value ===
            (typeof this.activityForm.activityId === 'object'
              ? this.activityForm.activityId.value
              : this.activityForm.activityId),
        );
        if (this.isEditing) {
          payload.id = this.editingId;
          await this.$api.put(
            `TranProgramModuleActivity/${payload.id}`,
            payload,
          );
          this.activeScheduleComponent.updateActivity({
            ...this.activityForm,
            startAtDay: this.startAtDay,
            activityModuleMappingId: this.editingId,
            name: target?.name || '',
            color: target?.color || '',
            code: target?.code || null,
          });
          this.$swal(
            'Thành công!',
            'Đã cập nhật hoạt động thành công',
            'success',
          );
        } else {
          const { data } = await this.$api.post(
            'TranProgramModuleActivity',
            payload,
          );
          this.activeScheduleComponent.addActivity({
            ...this.activityForm,
            startAtDay: this.startAtDay,
            activityModuleMappingId: data.id,
            name: target?.name || '',
            id: data.id || Date.now().toString(),
            color: target?.color || this.defaultColor,
            code: target?.code || null,
          });
          this.$swal('Thành công!', 'Đã thêm hoạt động thành công', 'success');
        }
        this.hideModal();
      } catch (error) {
        console.error('Error saving activity:', error);
        this.$swal('Lỗi!', 'Đã có lỗi xảy ra', 'error');
      } finally {
        this.loading = false;
        this.loadModuleData();
      }
    },
    editActivity(activity) {
      console.log(activity);
      this.isEditing = true;
      this.editingId = activity.activityModuleMappingId;
      const week = activity.week || 1;
      const dayIndex = this.days.indexOf(activity.startDay);
      const finalDayIndex = dayIndex >= 0 ? dayIndex : 0;

      const activityItem = this.activities.find(
        (act) => act.value === (activity.activityId || activity.id),
      );

      if (activityItem && activity.activityId != null) {
        const activityTypeId = activityItem.activityType;
        const selectedActivityType = this.activityTypes.find(
          (type) => type.value === activityTypeId,
        );
        if (selectedActivityType) {
          this.activityTypeForm.activityTypeId = selectedActivityType;
        } else {
          console.warn(
            `ActivityTypeId ${activityTypeId} not found in activityTypes`,
          );
          this.activityTypeForm.activityTypeId = '';
        }

        this.activityForm = {
          activityId: {
            ...activityItem,
            displayName: activityItem.code
              ? `(${activityItem.code}) ${activityItem.name}`
              : activityItem.name,
          },
          startWeek: week,
          color: activity.color || '#16A45A',
        };
      } else {
        console.warn(
          `Activity not found in activities: ${
            activity.activityId || activity.id
          }`,
        );
        this.activityTypeForm.activityTypeId = '';
        this.activityForm = {
          activityId: {
            value: activity.activityId || activity.id,
            name: activity.title || 'Không xác định',
            displayName: activity.code
              ? `(${activity.code}) ${activity.title || 'Không xác định'}`
              : activity.title || 'Không xác định',
            code: activity.code || null,
          },
          startWeek: week,
          color: activity.color || '#16A45A',
        };
      }

      this.selectedDay = finalDayIndex;

      this.$nextTick(() => {
        this.$forceUpdate();
      });

      this.$refs.moduleModal.show();
    },
    async deleteActivity(activityModuleMappingId) {
      try {
        this.loading = true;
        await this.$api.delete(
          `TranProgramModuleActivity/${activityModuleMappingId}`,
        );
        this.$swal('Thành công!', 'Đã xóa hoạt động thành công', 'success');
      } catch (error) {
        this.$swal('Lỗi!', 'Đã có lỗi xảy ra khi xóa hoạt động', 'error');
      } finally {
        this.loading = false;
      }
    },
    async loadModuleData() {
      if (!this.$route.params.id) return;
      try {
        this.loading = true;
        const id = this.$route.params.id;

        let { data: moduleData } = await this.$api.get(
          `TranProgramModule/Activity/${id}`,
        );

        let { data: dataModuleActivities } = await this.$api.get(
          `TranProgramModuleActivity?tranProgramModuleId=${id}&size=1000`,
        );

        const activities = dataModuleActivities.items.map((activityMapping) => {
          const activity = moduleData.activities.find(
            (act) => act.id === activityMapping.tranProgramActivityId,
          );
          return {
            id: activityMapping.tranProgramActivityId,
            name: activity?.name || 'Không xác định',
            startAtDay: activityMapping.startranAtranDay,
            color: activity?.color || '#16A45A',
            activityModuleMappingId: activityMapping.id,
            code: activity?.code || null,
          };
        });

        moduleData.activities = activities;
        this.moduleData = moduleData;
        this.numberOfWeeks = moduleData.totalWeek || this.numberOfWeeks;

        if (this.$refs.ScheduleProgramModuleDay) {
          this.$refs.ScheduleProgramModuleDay.updateNumberOfWeeks(
            this.numberOfWeeks,
          );
        }
      } catch (error) {
        console.error('Error loading module data:', error);
        this.$swal('Lỗi!', 'Không thể tải dữ liệu module', 'error');
        this.moduleData = { activities: [] };
        this.numberOfWeeks = 0;
      } finally {
        this.loading = false;
      }
    },
    async loadActivityType() {
      try {
        this.loading = true;
        const { data } = await this.$api.get(
          `/ProgramActivityLevel/setup-list`,
        );
        this.activityTypes = data.Types.map((item) => ({
          value: item.Id,
          name: item.Name,
        }));
      } catch (error) {
        console.error('Error loading activityType:', error);
        this.$swal('Lỗi!', 'Không thể tải danh sách loại hoạt động', 'error');
        this.activityTypes = [];
      } finally {
        this.loading = false;
      }
    },
    async loadActivities() {
      try {
        this.loading = true;
        const { data } = await this.$api.get('/ProgramActivity/All');
        this.activities = data.map((item) => ({
          value: item.id || '',
          name: item.name || 'Không có tên',
          activityType: item.activityTypeId,
          code: item.code || null,
        }));
      } catch (error) {
        console.error('Error loading activities:', error);
        this.$swal('Lỗi!', 'Không thể tải danh sách hoạt động', 'error');
        this.activities = [];
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    '$route.params.id': {
      handler(newId) {
        if (newId) {
          this.loadModuleData();
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    try {
      await Promise.all([this.loadActivityType(), this.loadActivities()]);
    } catch (error) {
      console.error('Error during mounted:', error);
    }
  },
};
</script>

<style scoped>
.font-weight-bold {
  font-weight: 600;
}

.header-buttons-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.navigation-buttons {
  display: flex;
  align-items: center;
}

.form-container {
  padding: 10px;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.form-group {
  flex: 1;
  min-width: 300px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
}

.custom-btn {
  border: 1px solid #008479 !important;
  color: #008479 !important;
  background-color: transparent;
}

.toggle-text.active {
  font-weight: bold;
}

/* Responsive styling */
@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
  }

  .form-group {
    flex: 1;
  }
}
</style>
